import { Card, Col, Image, Row, Typography, Divider } from 'antd';
import React from 'react';

const { Title, Paragraph } = Typography;

export default function ResearchTeam() {

    const boss = {
        name: "袁慧军",
        avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/yuanhuijun.jpg',
        nameEng: "Huijun Yuan",
        title: "Project Chair",
        desc: "Professor and Director of the Rare Disease Research Institute"
    }

    const members = [
        {
            name: '程静',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/chengjing.jpg',
            nameEng: "Jing Cheng",
            title: "Principal Investigator"
        },
        {
            name: '卜枫啸',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/bufengxiao.jpg',
            nameEng: "Fengxiao Bu",
            title: "Principal Investigator"
        },
        {
            name: '吴洋',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/wuyang.jpg',
            nameEng: "Yang Wu",
            title: "Principal Investigator"
        },
        {
            name: "何光林",
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/heguanglin.jpg',
            nameEng: "Guanglin He",
            title: "Principal Investigator"
        },
        {
            name: '卢宇',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/luyu.jpg',
            nameEng: "Yu Lu",
            title: "Principal Investigator"
        },
        {
            name: '巫柯',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/wuke.jpg',
            nameEng: "Ke Wu",
            title: "Principal Investigator"
        },
        {
            name: '张英杰',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/members/zhangyingjie.jpg',
            nameEng: "Yingjie Zhang",
            title: "Principal Investigator"
        },
        // 新增 Principal Investigator 成员，头像使用用户提供的服务器图片地址
        {
            name: '张根',
            avatar: 'https://gsrd-server.tos-cn-beijing.volces.com/zhanggen.jpg',
            nameEng: "Gen Zhang",
            title: "Principal Investigator"
        },
    ]

    // Optimized image parameters for faster loading and better quality
    const ImageFooter = "?x-oss-process=image/resize,m_lfit,w_400/quality,q_80/format,webp"

    const memberCardStyle = {
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '16px', // Reduced padding
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
        transition: 'all 0.3s ease',
        cursor: 'default',
        width: '100%',
        boxSizing: 'border-box'
    };

    const renderMemberCard = (member, isLarge = false) => (
        <div 
            style={{
                ...memberCardStyle,
                padding: isLarge ? '30px' : '16px',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.05)';
            }}
        >
            <div style={{
                width: isLarge ? '180px' : '130px', // Shrunk
                height: isLarge ? '240px' : '170px', // Shrunk
                marginBottom: '16px',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 4px 10px rgba(0,0,0,0.08)'
            }}>
                <Image
                    src={member.avatar + ImageFooter}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                    preview={{
                        src: member.avatar,
                    }}
                />
            </div>
            <Title level={isLarge ? 3 : 5} style={{ color: '#055878', margin: '0 0 4px', fontSize: isLarge ? '24px' : '18px' }}>
                {member.name}
            </Title>
            <Paragraph style={{ fontSize: isLarge ? '16px' : '14px', fontWeight: 600, color: '#13769a', marginBottom: '8px' }}>
                {member.nameEng}
            </Paragraph>
            <div style={{ 
                backgroundColor: isLarge ? '#055878' : '#f0f9ff', 
                color: isLarge ? 'white' : '#055878',
                padding: '3px 10px',
                borderRadius: '15px',
                fontSize: '12px',
                fontWeight: 600,
                marginTop: 'auto'
            }}>
                {member.title}
            </div>
            {isLarge && member.desc && (
                <Paragraph style={{ marginTop: '12px', color: '#666', fontStyle: 'italic', fontSize: '13px' }}>
                    {member.desc}
                </Paragraph>
            )}
        </div>
    );

    return (
        <div className="shared-hero-page" style={{ backgroundColor: '#f9f9f9', minHeight: '100vh', paddingBottom: '80px' }}>
            {/* Hero Section */}
            <div className="shared-hero-banner" style={{
                padding: '100px 20px 80px',
                textAlign: 'center',
                color: 'white',
                marginBottom: '60px'
            }}>
                <Title level={1} style={{ color: 'white', fontSize: '3.5rem', fontWeight: 800, marginBottom: '24px' }}>
                    Our Research Team
                </Title>
            </div>

            <Row justify="center">
                <Col xs={22} sm={20} lg={18}>
                    {/* Project Chair Section */}
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <Divider orientation="left" style={{ borderColor: '#055878', fontSize: '24px', fontWeight: 700, color: '#055878' }}>
                            Project Leadership
                        </Divider>
                    </div>
                    
                    <Row justify="center" style={{ marginBottom: '80px' }}>
                        <Col xs={24} sm={18} md={12} lg={10}>
                            {renderMemberCard(boss, true)}
                        </Col>
                    </Row>

                    {/* Principal Investigators Section */}
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <Divider orientation="left" style={{ borderColor: '#055878', fontSize: '24px', fontWeight: 700, color: '#055878' }}>
                            Principal Investigators
                        </Divider>
                    </div>

                    <Row gutter={[24, 24]} justify="center">
                        {members.map((member, index) => (
                            <Col key={index} xs={12} sm={12} md={8} lg={6}>
                                {renderMemberCard(member)}
                            </Col>
                        ))}
                    </Row>

                    {/* Team Photo Section */}
                    <div style={{ marginTop: '80px', textAlign: 'center' }}>
                         <Title level={2} style={{ color: '#055878', marginBottom: '30px' }}>Global Collaboration</Title>
                        <Card bordered={false} bodyStyle={{ padding: 0 }} style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
                            <Image 
                                src={"https://gsrd-server.tos-cn-beijing.volces.com/Organizations/thanks/image1.jpeg"}
                                style={{ width: '100%', display: 'block' }}
                                preview={{
                                    mask: <div style={{ fontSize: '1.2rem' }}>View Full Image</div>
                                }}
                            />
                        </Card>
                    </div>
                </Col>
            </Row>
        </div>
    )
}
